import React, { useEffect, useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import Nav from '../Nav';
import { updateActiveSecondary } from '../../redux/slices/ui/nav';
import filterNavItems from '../../_shared/helpers/filterNavItems';
import renderNavItems from '../../_shared/helpers/renderNavItems';
import { TradeStateEnumMap } from '../../_shared/types/trade';
import ReducerConstants from '../../_shared/constants/reducers';
import renderLocale from '../../_shared/helpers/renderLocale';
import { NavSecondaryWrapper } from './Styles';
import { COOKIES } from '../../_shared/constants/cookies';
import { getCookie } from '../../_shared/utils/cookies';

const NavSecondary = ({ tradeState }) => {
  const [{ position, items }, { context }, authLoginResponse] = useSelector(
    state => [
      state?.ui?.nav?.secondary,
      state?.ui?.nav?.primary,
      state[ReducerConstants.AUTH]
    ],
    shallowEqual
  );

  const { pathname } = useLocation();
  const [tradeCurrentState, setTradeCurrentState] = useState(null);
  const [secondaryItems, setSecondaryItems] = useState([]);
  const [currentContext, setCurrentContext] = useState(null);

  const isDMPCheckoutEnabled =
    getCookie(COOKIES.IS_DMP_CHECKOUT_ENABLED) === 'true';

  useEffect(() => {
    let filteredItems = items?.[context] || [];
    filteredItems = filterNavItems(
      filteredItems,
      authLoginResponse,
      isDMPCheckoutEnabled
    );

    const currentIds = filteredItems.map(({ id }) => id);
    const secondaryItemsIds = secondaryItems.map(({ id }) => id);

    if (
      currentContext !== context ||
      JSON.stringify(currentIds) !== JSON.stringify(secondaryItemsIds)
    ) {
      setSecondaryItems(filteredItems);
      setCurrentContext(context);
    }
  }, [context, authLoginResponse?.user]); //eslint-disable-line

  useEffect(() => {
    setTradeCurrentState(
      tradeState || TradeStateEnumMap[pathname.split('/')[2]]
    );
  }, [pathname, tradeState]);

  const locale = renderLocale(authLoginResponse);
  return (
    <NavSecondaryWrapper>
      <Nav testId="navSecondary" position={position} variant="Secondary">
        {renderNavItems(
          secondaryItems,
          pathname,
          updateActiveSecondary,
          tradeCurrentState,
          locale
        )}
      </Nav>
    </NavSecondaryWrapper>
  );
};

export default NavSecondary;
